import React, { useState, useEffect } from "react";

import { DRAWER_BACKGROUND } from "../../../constants/styles";
import { OMNISCAN_BLUE } from "../../../constants/colors";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faFolder,
    faFolderOpen
}
from "@fortawesome/free-solid-svg-icons";

export default function FolderForagerTreePanel(
{
    directories = [],
    selectedDirectory,
    onSelect,
    onExpand
})
{
	console.log("DIRECTORIES", directories);
    const [collapsed,
           setCollapsed] =
        useState(false);

    return (

        <div
            style={{
                position: "fixed",

                top: "15px",
                left: "60px",
                bottom: "15px",

                width:
                    collapsed
                        ? "58px"
                        : "320px",

                transition: "width .35s ease",

                background: DRAWER_BACKGROUND,

                boxShadow:
                    "10px 0 30px rgba(0,0,0,.35)",

                borderRadius:
                    "0 12px 12px 0",

                overflow: "visible",

                zIndex: 500
            }}
        >

            {/* Collapse */}

            <div
                onClick={() =>
                    setCollapsed(!collapsed)
                }

                style={{
                    position: "absolute",

                    top: "16px",
                    right: "-17px",

                    width: "34px",
                    height: "34px",

                    borderRadius: "50%",

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",

                    cursor: "pointer",

                    background:
                        "rgba(28,32,40,.98)",

                    border:
                        "1px solid rgba(255,255,255,.12)",

                    color: "white",

                    boxShadow:
                        "0 10px 24px rgba(0,0,0,.45)"
                }}
            >

                <FontAwesomeIcon
                    icon={
                        collapsed
                            ? faChevronRight
                            : faChevronLeft
                    }
                />

            </div>

            {/* Header */}

            <div
                style={{
                    height: "54px",

                    display: "flex",

                    alignItems: "center",

                    paddingLeft: "18px",

                    color: "white",

                    fontWeight: 600,

                    borderBottom:
                        "1px solid rgba(255,255,255,.08)"
                }}
            >

                <FontAwesomeIcon
                    icon={faFolderOpen}
                />

                {!collapsed &&

                    <span
                        style={{
                            marginLeft: "10px"
                        }}
                    >
                        Documents
                    </span>

                }

            </div>

            {/* Tree */}

            <div
                style={{
                    padding: "10px",

                    overflowY: "auto",

                    height: "calc(100% - 54px)"
                }}
            >

                {

                    directories.map(directory =>

                        <FolderTreeNode

                            key={directory.id}

                            directory={directory}

                            collapsed={collapsed}

                            selected={
                                selectedDirectory &&
                                selectedDirectory.id === directory.id
                            }

                            onSelect={onSelect}

                            onExpand={onExpand}

                        />

                    )

                }

            </div>

        </div>

    );

}



function FolderTreeNode(
{
    directory,
    collapsed,
    selected,
    onSelect,
    onExpand
})
{
   

    const selectedGradient =
        `linear-gradient(
            180deg,
            #7fc9ff 0%,
            ${OMNISCAN_BLUE} 100%
        )`;
		
		

    return (

        <>

            <div

                style={{

                    display: "flex",

                    alignItems: "center",

                    padding:
                        collapsed
                            ? "10px 0"
                            : "8px 10px",

                    borderRadius: "8px",

                    background:
                        selected
                            ? selectedGradient
                            : "transparent"

                }}

            >

                {/* Expand */}

                {

                    !collapsed &&

                    <div

					onClick={(e) =>
					{
					    e.stopPropagation();

					    if(onExpand)
					    {
					        onExpand(directory);
					    }
					}}

                        style={{

                            width: "18px",

                            cursor: "pointer",

                            color:
                                "rgba(255,255,255,.75)",

                            flexShrink: 0

                        }}

                    >

                        <FontAwesomeIcon

                            icon={
                                directory.expanded
                                    ? faChevronDown
                                    : faChevronRight
                            }

                        />

                    </div>

                }

                {/* Folder */}

                <div

                    onClick={() =>
                    {
                        if(onSelect)
                        {
                            onSelect(directory);
                        }
                    }}

                    style={{

                        display: "flex",

                        alignItems: "center",

                        cursor: "pointer",

                        color: "white"

                    }}

                >

                    <FontAwesomeIcon
						style={{color:OMNISCAN_BLUE}}
                        icon={
                            directory.expanded
                                ? faFolderOpen
                                : faFolder
                        }

                    />

                </div>

                {/* Text */}

                {

                    !collapsed &&

                    <div

                        onClick={() =>
                        {
                            if(onSelect)
                            {
                                onSelect(directory);
                            }
                        }}

                        style={{
							fontSize:'13px',
                            marginLeft: "12px",

                            cursor: "pointer",

                            color:
                                "rgba(255,255,255,.88)",

                            userSelect: "none"

                        }}

                    >

                        {directory.name}

                    </div>

                }

            </div>

            {/* Placeholder for recursion */}

            {

                directory.expanded &&
                !collapsed &&

                <div
                    style={{
                        marginLeft: "22px"
                    }}
                >

                    {

                        directory.children &&

                        directory.children.map(child =>

                            <FolderTreeNode

                                key={child.id}

                                directory={child}

                                collapsed={collapsed}

                                selected={
                                    selected &&
                                    selected.id === child.id
                                }

                                onSelect={onSelect}

                                onExpand={onExpand}

                            />

                        )

                    }

                </div>

            }

        </>

    );

}